import React, { useEffect, useState } from "react";
import Layout from "../../../Layout";
import { Skeleton } from "primereact/skeleton";
import LspCompanyInfo from "./components/LspCompanyInfo";
import { useParams } from "react-router-dom";
import useLspUpdating from "../actions/useLspUpdating";
import QuickAccess from "./components/QuickAccess";
import LspCustomers from "./components/LspCustomers";
import useLspDashboard from "../actions/useLspDashboard";
import LspCountriesServices from "./components/LspCountriesServices";

const LSPDashboard = () => {
  const { id } = useParams();
  const {
    lspdata,
    genstate,
    isLogin,
    email,
    onEnityPageChange,
    onServiceChange,
  } = useLspUpdating(id, true);

  const { handleCustomerView } = useLspDashboard(id);
  return (
    <>
      <Layout
        crumbs={[
          { label: "Local Service Partners", url: "/lsp", id: "lsps" },
          {
            label: (
              <div className="flex">
                {genstate.status === "getlsploading" ? (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                ) : (
                  lspdata?.name
                )}
              </div>
            ),
            id: "lsps ",
          },
        ]}
        SideNavSection={() =>
          !email && !isLogin ? (
            <></>
          ) : (
            <div className="sidenav-quick-access">
              {" "}
              <QuickAccess lspInfo={{ id: id }} />{" "}
            </div>
          )
        }
      >
        <div className="lsp-dashboard">
          <LspCompanyInfo
            lspInfo={lspdata}
            isLoading={genstate.status === "getlsploading"}
          />
          <LspCustomers
            lspInfo={lspdata}
            isloading={genstate.status === "getlsploading"}
            handleEdit={handleCustomerView}
            limit={genstate.entitypagelimit}
            page={genstate.entitypage}
            onChange={onEnityPageChange}
          />
          <LspCountriesServices
            isloading={genstate.status === "getlsploading"}
            onChange={onServiceChange}
            page={genstate.servicepage}
            limit={genstate.servicelimit}
            servicedata={genstate.countryServices}
          />
        </div>
      </Layout>
    </>
  );
};

export default LSPDashboard;
